import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IosAppCommunicationService {
  public setLinkPreview(enabled: boolean) {
    if (typeof window === 'undefined') return;
    window['webkit']?.messageHandlers?.linkPreview?.postMessage({ enabled });
  }
}
